import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ddt-web/common';

import { LastWordPipe } from './last-word.pipe';
import { SplitWordsAndRemoveLastPipe } from './split-words.pipe';


@NgModule({
	declarations: [SplitWordsAndRemoveLastPipe, LastWordPipe],
	imports: [
		CommonModule,
		SharedModule
	],
	exports: [SplitWordsAndRemoveLastPipe, LastWordPipe]
})
export class TableFormattingModule { }
